// import {DadJokes} from "./dadjokes";
import {DadJokes} from "./dadjokes";

export {
  DadJokes,
};
